export default __webpack_public_path__ + "static/media/illustration.18204c87.svg";